import {
  EVENT_BANNER_HEIGHT,
  EVENT_BANNER_WIDTH,
} from "../constants/eventBanner";

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

export const getImageDimensions = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not read image dimensions"));
    };
    image.src = url;
  });

export const isExactEventBannerSize = (width, height) =>
  width === EVENT_BANNER_WIDTH && height === EVENT_BANNER_HEIGHT;

/**
 * Draw the cropped region to a canvas and return a JPEG File at exact banner dimensions.
 */
export async function getCroppedEventBannerFile(
  imageSrc,
  pixelCrop,
  originalFileName = "event-banner.jpg"
) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = EVENT_BANNER_WIDTH;
  canvas.height = EVENT_BANNER_HEIGHT;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    EVENT_BANNER_WIDTH,
    EVENT_BANNER_HEIGHT
  );

  const blob = await new Promise((resolve) => {
    canvas.toBlob((b) => resolve(b), "image/jpeg", 0.92);
  });

  if (!blob) {
    throw new Error("Failed to crop banner image");
  }

  const baseName = String(originalFileName || "event-banner")
    .replace(/\.[^.]+$/, "")
    .slice(0, 80);

  return new File([blob], `${baseName}.jpg`, { type: "image/jpeg" });
}
